/* ============================================================
   VITASNOUT — interacciones globales (tema Shopify)
   ============================================================ */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasGSAP = window.gsap && !reduce;

    if (hasGSAP) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.utils.toArray('.reveal').forEach((el) => {
        gsap.to(el, { opacity: 1, y: 0, duration: .8, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 85%' } });
      });
      gsap.utils.toArray('.grid').forEach((grid) => {
        gsap.from(grid.children, { opacity: 0, y: 50, duration: .6, ease: 'back.out(1.5)', stagger: .06, scrollTrigger: { trigger: grid, start: 'top 80%' } });
      });
      gsap.utils.toArray('.shape').forEach((shape, i) => {
        const depth = parseFloat(shape.dataset.depth || (0.2 + (i % 4) * 0.12));
        gsap.to(shape, { yPercent: -40 * depth * 10, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
      });
      if (document.querySelector('.hero__wordmark span')) {
        gsap.from('.hero__wordmark span', { y: 80, opacity: 0, rotate: -8, duration: .7, ease: 'back.out(2)', stagger: .05, delay: .15 });
      }
    } else {
      document.querySelectorAll('.reveal').forEach((el) => { el.style.opacity = 1; el.style.transform = 'none'; });
    }

    /* Partículas del hero */
    const dotLayer = document.getElementById('dots');
    if (dotLayer) {
      const palette = ['#2dcab8', '#ffd500', '#cc3366', '#b5dc4a', '#08accf'];
      for (let i = 0; i < 26; i++) {
        const d = document.createElement('span');
        d.className = 'dot';
        const size = 4 + Math.random() * 10;
        d.style.width = d.style.height = size + 'px';
        d.style.left = Math.random() * 100 + '%';
        d.style.top = Math.random() * 100 + '%';
        d.style.background = palette[i % palette.length];
        d.style.opacity = (0.25 + Math.random() * 0.5).toFixed(2);
        dotLayer.appendChild(d);
        if (hasGSAP) gsap.to(d, { y: (Math.random() * 60 - 30), x: (Math.random() * 50 - 25), duration: 3 + Math.random() * 4, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: Math.random() * 2 });
      }
    }

    /* Carrusel favoritos */
    const fav = document.querySelector('[data-fav]');
    if (fav) {
      let items = [];
      try { items = JSON.parse(fav.dataset.fav); } catch (e) {}
      if (items.length) {
        let idx = 0;
        const nameEl = fav.querySelector('.fav__name');
        const descEl = fav.querySelector('.fav__desc');
        const eyebrow = fav.querySelector('.fav__eyebrow');
        const packEl = fav.querySelector('.fav__pack');
        const imgEl = fav.querySelector('.fav__pack-img');
        const svgEl = fav.querySelector('.fav__pack-svg');
        const buyBtn = fav.querySelector('.fav__buy');
        const render = () => {
          const it = items[idx];
          const apply = () => {
            nameEl.textContent = it.name;
            descEl.textContent = it.desc;
            if (eyebrow && it.eyebrow) eyebrow.textContent = it.eyebrow;
            if (packEl && it.color) packEl.style.setProperty('--pack', it.color);
            if (imgEl && svgEl) {
              if (it.img) { imgEl.src = it.img; imgEl.alt = it.name || ''; imgEl.style.display = 'block'; svgEl.style.display = 'none'; }
              else { imgEl.style.display = 'none'; svgEl.style.display = 'block'; }
            }
            if (buyBtn && it.url) buyBtn.href = it.url;
          };
          if (hasGSAP) {
            gsap.timeline()
              .to([nameEl, descEl, packEl], { opacity: 0, y: 12, duration: .2 })
              .add(apply)
              .to([nameEl, descEl, packEl], { opacity: 1, y: 0, duration: .35, ease: 'back.out(1.6)' });
          } else apply();
        };
        fav.querySelector('[data-prev]').addEventListener('click', () => { idx = (idx - 1 + items.length) % items.length; render(); });
        fav.querySelector('[data-next]').addEventListener('click', () => { idx = (idx + 1) % items.length; render(); });
        render();
      }
    }

    /* Testimonios */
    const testi = document.querySelector('[data-testi]');
    if (testi) {
      let data = [];
      try { data = JSON.parse(testi.dataset.testi); } catch (e) {}
      const tabs = testi.querySelectorAll('.testi__tab');
      const quote = testi.querySelector('.testi__quote');
      const who = testi.querySelector('.testi__who');
      const show = (i) => {
        tabs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        const d = data[i]; if (!d) return;
        const set = () => { quote.textContent = '“' + d.quote + '”'; who.textContent = d.who; };
        if (hasGSAP) gsap.timeline().to([quote, who], { opacity: 0, y: 10, duration: .18 }).add(set).to([quote, who], { opacity: 1, y: 0, duration: .3 });
        else set();
      };
      tabs.forEach((t, i) => t.addEventListener('click', () => show(i)));
      if (data.length) show(0);
    }

    /* Menú móvil */
    const burger = document.querySelector('.burger');
    const nav = document.querySelector('.nav');
    if (burger && nav) {
      burger.addEventListener('click', () => { nav.classList.toggle('is-open'); });
      window.addEventListener('resize', () => { if (window.innerWidth > 960) nav.classList.remove('is-open'); });
    }

    /* ---------- Ficha de producto ---------- */
    const pdp = document.querySelector('[data-product-section]');
    if (pdp) {
      // miniaturas
      const mainImg = pdp.querySelector('#pdp-main-img');
      const thumbs = Array.prototype.slice.call(pdp.querySelectorAll('.pdp__thumb'));
      thumbs.forEach((t, i) => {
        t.addEventListener('click', () => { if (mainImg) mainImg.src = t.dataset.thumb; galIdx = i; });
      });

      // swipe de la galería con el dedo (móvil)
      let galIdx = 0;
      const galMain = pdp.querySelector('.pdp__main');
      if (galMain && mainImg && thumbs.length > 1) {
        const srcs = thumbs.map((t) => t.dataset.thumb);
        const showGal = (i) => { galIdx = (i + srcs.length) % srcs.length; mainImg.src = srcs[galIdx]; };
        let sx = 0, sy = 0, drag = false, decided = false, horiz = false;
        galMain.addEventListener('pointerdown', (e) => {
          drag = true; decided = false; horiz = false; sx = e.clientX; sy = e.clientY;
          try { galMain.setPointerCapture(e.pointerId); } catch (err) {}
        });
        galMain.addEventListener('pointermove', (e) => {
          if (!drag) return;
          const dx = e.clientX - sx, dy = e.clientY - sy;
          if (!decided) { if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; decided = true; horiz = Math.abs(dx) > Math.abs(dy); }
          if (horiz && e.cancelable) e.preventDefault();
        });
        const endGal = (e) => {
          if (!drag) return; drag = false;
          if (!horiz) return;
          const dx = e.clientX - sx;
          if (dx <= -40) showGal(galIdx + 1);
          else if (dx >= 40) showGal(galIdx - 1);
        };
        galMain.addEventListener('pointerup', endGal);
        galMain.addEventListener('pointercancel', endGal);
      }

      // cantidad
      const qtyInput = pdp.querySelector('.qty__input');
      pdp.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      pdp.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

      // variantes
      let variants = [];
      const vjson = pdp.querySelector('[data-variant-json]');
      try { variants = JSON.parse(vjson.textContent); } catch (e) {}
      const idInput = pdp.querySelector('[data-variant-id]');
      const priceEl = pdp.querySelector('[data-price]');
      const compareEl = pdp.querySelector('[data-compare]');
      const atc = pdp.querySelector('[data-atc]');
      const atcText = pdp.querySelector('[data-atc-text]');

      function money(cents) {
        try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toLocaleString('es-CO'); }
        catch (e) { return '$' + (cents / 100).toFixed(0); }
      }
      function selectedOptions() {
        return Array.from(pdp.querySelectorAll('.pdp__option')).map((opt) => {
          const checked = opt.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function update() {
        const sel = selectedOptions();
        const match = variants.find((v) => v.options.every((o, i) => o === sel[i]));
        pdp.querySelectorAll('.pill').forEach((p) => p.classList.toggle('is-active', p.querySelector('input')?.checked));
        if (!match) { if (atc) { atc.disabled = true; atcText.textContent = 'No disponible'; } return; }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) compareEl.style.display = (match.compare_at_price > match.price) ? '' : 'none';
        if (atc) { atc.disabled = !match.available; atcText.textContent = match.available ? (atc.dataset.label || atcText.dataset.label || 'Agregar') : 'Agotado'; }
      }
      if (atcText) atcText.dataset.label = atcText.textContent;
      pdp.querySelectorAll('.pdp__option input').forEach((i) => i.addEventListener('change', update));

      // Selector de packs (bundle): cada card fija una variante real
      const bundleCards = pdp.querySelectorAll('[data-bundle-card]');
      if (bundleCards.length) {
        const setBundle = (card) => {
          if (card.classList.contains('is-soldout')) return;
          bundleCards.forEach((c) => c.classList.toggle('is-sel', c === card));
          const vid = card.dataset.vid;
          const v = variants.find((x) => String(x.id) === String(vid));
          if (idInput) idInput.value = vid;
          if (priceEl) priceEl.textContent = v ? money(v.price) : money(parseInt(card.dataset.price, 10));
          if (compareEl) {
            const cmp = v ? v.compare_at_price : 0;
            if (cmp && cmp > v.price) { compareEl.textContent = money(cmp); compareEl.style.display = ''; }
            else compareEl.style.display = 'none';
          }
          if (atc && v) { atc.disabled = !v.available; if (atcText) atcText.textContent = v.available ? (atcText.dataset.label || 'Agregar') : 'Agotado'; }
        };
        bundleCards.forEach((card) => card.addEventListener('click', () => setBundle(card)));
        const initial = pdp.querySelector('[data-bundle-card].is-sel') || bundleCards[0];
        if (initial) setBundle(initial);
      }
    }

    /* Feedback visual al agregar (no bloquea el submit real a /cart/add) */
    document.querySelectorAll('[data-add]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const countEl = document.querySelector('.cart__count');
        if (countEl) {
          countEl.textContent = (parseInt(countEl.textContent, 10) || 0) + 1;
          if (window.gsap) gsap.fromTo(countEl, { scale: 1.6 }, { scale: 1, duration: .4, ease: 'back.out(3)' });
        }
      });
    });
  });
})();
